import {GetHealthAvailableTimes} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetHealthAvailableTimes} from 'data/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthAvailableTimes = (): GetHealthAvailableTimes =>
	new RemoteGetHealthAvailableTimes(
		makeBFFApiUrl(BookingFlowEndPoints.healthAvailableTimes),
		makeAuthorizeHttpClientDecorator(),
	);
